import api from '@/api'

export default {
  fetchStreets (search) {
    return api.get(`/addresses?search=${search}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/streetService.js